<div>
  <div>
    @if (loading) {
      <app-sign-in [loading]="true"></app-sign-in>
    }
    @if (!loading) {
      <router-outlet></router-outlet>
    }
  </div>
</div>
